import PropTypes from 'prop-types';

export default {
    departmentName: PropTypes.string,
    telephoneNumber: PropTypes.string,
    emailAddress: PropTypes.string,
    contactDetailsType: PropTypes.oneOf(['Emergency', 'Business'])
};
